<template>
  <div>
    <vxe-grid
      ref="predictTable"
      auto-resize
      highlight-hover-row
      resizable
      border
      size="mini"
      cell-class-name="align-top"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
    >
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'

import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { typ: String, default: '' },
    amazonStoreRegion: { typ: String, default: '' },
    highlightCurrentRow: { typ: Boolean, default: false },
  },
  data() {
    return {
      addDialogVisible: false,
      format: (number) => format(number),
      tableData: [],
      loading: false,
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzFirstDemandCode || !this.amazonStoreRegion) return

      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandPromotionListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          amazonStoreRegion: this.amazonStoreRegion,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data || []
      await this.initializeMonthData()
    },
    async initializeMonthData() {
      const relTableData = []
      for (let i = 1; i < 13; i++) {
        const index = this.tableData.findIndex((e) => parseInt(e.month) == i)
        if (index == -1) {
          relTableData.push({
            month: i.toString(),
            plannedSales: 0,
            unitPrice: 0,
            salesAmount: 0,
            profitRate: 0,
            profitAmount: 0,
            totalProfitAmount: 0,
          })
        } else {
          relTableData.push({
            ...this.tableData[index],
          })
        }
      }
      this.tableData = relTableData
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
